import { Component, Input } from '@angular/core';
import { Zuweisung } from 'src/app/domain/model/zuweisung';

@Component({
    selector: 'ufla-zuweisung-card',
    templateUrl: './zuweisung-card.component.html',
    styleUrls: [
        './zuweisung-card.component.scss',
    ],
    standalone: false,
})
export class ZuweisungCardComponent {

  @Input() zuweisung: Zuweisung;

  constructor() { }


  public get kurzbeschreibungShortened(): string {
      const tmp = this.zuweisung.aufgabe.kurzbeschreibung;
      return tmp == null ? '' : tmp.length > 100 ? tmp.substring(0, 100) + '...' : tmp;
  }

}
